import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { merge, Observable, of, Subject } from "rxjs";
import { map, startWith, switchMap, takeUntil } from "rxjs/operators";
import { itemSkuMapping, quickSkumapping, setSkuMapping, skuQuickmapping } from "src/app/models/inventory.model";
import { InventoryService } from "src/app/services/inventory.service";
import { SnackbarComponent } from "../snackbar/snackbar.component";

@Component({
  selector: "app-quick-mapping-popup",
  templateUrl: "./quick-mapping-popup.component.html",
  styleUrls: ["./quick-mapping-popup.component.scss"],
})
export class QuickMappingPopupComponent implements OnInit,OnDestroy {
  spin:boolean = false;
  searchInput: FormControl = new FormControl();
  selectedSkus: any[] = [];
  addToShipmentSkus$: Observable<any> = new Observable();
  checked: boolean;
  master_checked: boolean = false;
  radioOption: FormControl = new FormControl("SKU");
  selectedVendor: FormControl = new FormControl(null);
  unMappedskus:any[] = [];
  account: string;
  startRow:number=0;
  amountPerPage:number=10;
  loading: boolean = false;
  radioButtonOptions = [{
    value:'SKU',
    name:'SKU'
  },{
    value:'ASIN',
    name:'ASIN'
  }]
  title: string;
  startDate: number = 0;
  endDate:number = 100;
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<QuickMappingPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private inventoryService:InventoryService,
    private snackBar:MatSnackBar
  ) {}
 
  ngOnInit(): void {
    this.title = 'Quick mapping for '+this.data.accountSelected;
    this.getSkuQuickMapping();
    this.setSearch();
  }

  getSkuQuickMapping(){
    this.loading = true;
    const payload : quickSkumapping ={
        type: this.data.channelType,
        account: this.data.accountSelected,
        startRow: this.startDate,
        endRow: this.endDate
    }
    this.inventoryService.getSkuQuickMapping(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: skuQuickmapping) => {
      this.loading = false;
      res.getSkuQuickMappingResposne.filter((item)=> {
        const image = item.imageUrl;
        item.imageUrl = image ? image.replace("http://ecx.images-amazon.com/","https://m.media-amazon.com/") : "assets/images/No_image.png";
        });
      this.unMappedskus.push(...res.getSkuQuickMappingResposne);
      this.setSearch();
      this.selectAll();
    },
     error: (err) => {
      this.loading = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error,
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  clearSearch() {
    this.searchInput.setValue("");
  }

  dialogAction(e) {
    if (e === "Create") {
      this.createProduct();
    } else {
      this.close();
    }
  }

  createProduct(){
    this.spin = true;
    const isSkus = this.radioOption.value === 'SKU' ? true : false;
    const itemSkuMapping : itemSkuMapping[] = this.selectedSkus.map((sku) => {
      return {
        accountSkuId: sku.accountSkuId,
        qty:+sku.mapQty
      };
    });

    const payload : setSkuMapping ={
      vendorId: Number(+this.selectedVendor.value),
      isSku: isSkus,
      itemSkuMapping:itemSkuMapping
    }
    this.inventoryService.SetItemSkuMapping(payload).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res) => {
      if(res){
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "Operation successful",
              action: 'Dismiss',
              type: 'success',
            },
          }
        );
      }
      this.inventoryService.updateUnmappedSkus$.next(true);
      this.spin = false;
      this.close();
    },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: "Operation unsuccessful",
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
      this.inventoryService.updateUnmappedSkus$.next(true);
      this.spin = false;
      this.close();
     }
   });
  }

  close() {
    this.dialogRef.close();
  }

  selectAll() {
    if (this.selectedSkus.length == this.unMappedskus.length || this.master_checked)
      for (let value of Object.values(this.unMappedskus)) {
        value.checked = this.master_checked;
        value.mapQty = 1;
      }
    this.isSelectAll();
  }

  isSelectAll(){
    if (this.master_checked) {
      this.selectedSkus = [];
      this.unMappedskus.forEach(val => this.selectedSkus.push(Object.assign({}, val)));
    } else if (this.selectedSkus.length == this.unMappedskus.length && !this.master_checked) {
      this.selectedSkus = [];
    }
  }

  selectUnmappedSku(event: MatCheckboxChange, sku) {
    if (event.checked) {
      sku.mapQty=1;
      this.selectedSkus.push(sku);
      this.selectedSkus.length == this.unMappedskus.length ? this.master_checked = true : this.master_checked = false;
    } else {
      const unselectSkuIndex = this.selectedSkus.findIndex((item: any) => {
        return item.sku === sku.sku;
      });
      this.selectedSkus.splice(unselectSkuIndex, 1);
      this.master_checked=false;
    }
  }

  private setSearch() {
    this.addToShipmentSkus$ = merge(this.searchInput.valueChanges).pipe(
      startWith(""),
      switchMap(() => of(this.unMappedskus)),
      map((skus: any[]) => {
        if (!this.searchInput.value) {
          return skus;
        } else {
          return skus.filter((sku) => {
            return (
              sku.sku?.toLowerCase()
                .includes(this.searchInput.value.toLowerCase()) ||
              (sku.fnSku &&
                sku.fnSku?.toLowerCase()
                  .includes(this.searchInput.value.toLowerCase())) ||
              (sku.asin &&
                sku.asin?.toLowerCase()
                  .includes(this.searchInput.value.toLowerCase())) ||
              (sku.title &&
                sku.title?.toLowerCase()
                  .includes(this.searchInput.value.toLowerCase()))
            );
          });
        }
      })
    );
  }

  setSelectAll(event){
    this.master_checked = event.checked;
    this.selectAll();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
